<template>
  <modal @before-open="beforeOpen" transition="pop-out" name="level" :width="550" :height="650">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700">Level Form</p>
    </div>
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="border w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Description
          </label>
          <textarea v-model="form.description" class="border w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="Category Name"></textarea>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Minimum Amount
          </label>
          <input v-model="form.min_amount" class="border w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="Category Name">
          <p v-if="errors.includes('min_amount')" class="text-red-500 text-xs italic">Please provide a Minimum Amount.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Minimum Point
          </label>
          <input v-model="form.min_point" class="border w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="Category Name">
          <p v-if="errors.includes('min_point')" class="text-red-500 text-xs italic">Please provide a Minimum Point.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Percentage
          </label>
          <input v-model="form.percent" class="border w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="Category Name">
          <p v-if="errors.includes('percent')" class="text-red-500 text-xs italic">Please provide a Percentage.</p>
        </div>
        <div v-if="type === 'create'" class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="loading">Create</el-button>
        </div>
        <div v-if="type === 'edit'" class="flex items-center justify-between">
          <el-button @click="update" type="primary" :loading="loading">Update</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'LevelForm',
  data() {
    return {
      errors: [],
      form: {
        name: null,
        min_amount: null,
        min_point: null,
        percent: null,
        description: null,
      },
      loading: false,
      type: 'create',
      levelId: null,
    };
  },
  methods: {
    async submit() {
      this.errors = [];
      this.errors = this.validation(this.form, ['description']);

      if (this.errors.length === 0) {
        try {
          this.loading = true;
          await this.$store.dispatch('LoyaltyModule/createLevel', { payload: this.form });
          this.$notify.success({
            title: 'Success',
            message: 'New Loyalty Level added',
          });

          this.$modal.hide('level');

          this.loading = false;
        } catch (e) {
          this.loading = false;

          if (e.errors) {
            this.$notify.error({
              title: 'Error',
              message: e.errors[0],
            });
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
        }
      }
    },

    async update() {
      this.errors = [];
      this.errors = this.validation(this.form, ['description']);

      if (this.errors.length === 0) {
        try {
          this.loading = true;
          await this.$store.dispatch('LoyaltyModule/updateLevel', {levelId: this.levelId, payload: this.form });
          this.$notify.success({
            title: 'Success',
            message: 'Loyalty Level updated',
          });

          this.loading = false;

          this.$modal.hide('level');
        } catch (e) {
          this.loading = false;

          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }
      }
    },

    beforeOpen({ params }) {
      if (params && params.level && params.levelId) {
        this.type = 'edit';
        this.form = params.level;
        this.levelId = params.levelId;
      }
    },
  },
};
</script>

<style scoped>

</style>
